import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';

import { FeatureErrorBoundary } from '@nucleus-commerce/admin-kit/errors';

import { useStore } from '@/shared/store/store-context';

import { ProductionBoardView } from '../components/production-board-view';
import type { ProductionBoardSearch } from '../schemas/production-board-search';

const ROUTE_ID = '/_authed/_active/s/$storeId/production' as const;
const ROUTE_PATH = '/s/$storeId/production' as const;

function ProductionBoard() {
  const store = useStore();
  const search = useSearch({ from: ROUTE_ID });
  const navigate = useNavigate({ from: ROUTE_PATH });
  const patchSearch = useCallback(
    (patch: Partial<ProductionBoardSearch>) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }) }),
    [navigate],
  );
  return <ProductionBoardView store={store} search={search} onSearchChange={patchSearch} />;
}

export function ProductionBoardPage() {
  return (
    <FeatureErrorBoundary name="production.board">
      <ProductionBoard />
    </FeatureErrorBoundary>
  );
}
